<template>
<div class="menu">

    <div class="nav-wrap">
      <div class="close" @click="toggleMenu">
        <IconCancel class="icon-cancel" />
      </div>
    </div>

    <div class="content-wrap">
        <router-link to="/"><h1 class="button-text-white hover-margin-lt-big" @click="toggleMenu()">Feed</h1></router-link>
        <h1 class="button-text-white hover-margin-lt-big" @click="togglePopMess('Ranking are coming soon')">Rankings</h1>
        <h1 class="button-text-white hover-margin-lt-big" @click="toggleLogin()">Profile</h1>
        <h1 class="button-text-white hover-margin-lt-big" @click="toggleCreatePost(); togglePopMess('You have to Login to Post')">Post Debate</h1>
        <br>
        <p class="button-text-grey hover-margin-lt" @click="toggleAbout(); toggleMenu();">About</p>
        <p class="button-text-grey hover-margin-lt" @click="toggleLegal('terms'); toggleMenu();">Legal</p>
        <p class="button-text-grey hover-margin-lt" @click="toggleContact(); toggleMenu();">Contact</p>
        <!-- <p @click="togglePopMess('Working on it')">Press</p> -->
    </div>

    <div class="bottom-links">

            <p class="minor">
                <a class="button-text-grey" href="https://www.instagram.com/formation.network/" target="_blank">
                  <span>Instagram</span>
                </a>
                <a class="button-text-grey" href="https://twitter.com/formation_fyi" target="_blank">
                  <span>Twitter</span>
                </a>
                <a class="button-text-grey" href="https://communityinviter.com/apps/formation-fyi/formation" target="_blank">
                    <span>Slack (feedback)</span>
                </a>
                <!-- <a href="https://www.youtube.com/channel/UCoUNkGsgox0iqHQBxNc_zVA/" target="_blank">
                  <span>YouTube</span>
                </a> -->
            </p>

    </div>

</div>
</template>

<script>
import { db, auth } from '../db'
import IconCancel from '../assets/icons/IconCancel.vue'

export default {
  name: 'Menu',
  props: [
    "userinfo"
  ],
  components: {
    IconCancel
  },
  methods: {
    toggleMenu() {
      this.$store.commit('toggleMenu')
    },
    toggleCreatePost() {
      this.$store.commit('toggleCreatePost')
    },
    toggleLogin() {
      this.$store.commit('toggleLogin')
    },
    toggleLegal(payload) {
      this.$store.commit('toggleLegal', payload)
    },
    toggleAbout(payload) {
      this.$store.commit('toggleAbout', payload)
    },
    toggleContact(payload) {
      this.$store.commit('toggleContact', payload)
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    }
  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.menu {
  position: fixed;
  left: 0;
  height: 100%;
  overflow-y: scroll;
  background-color: $black;
  color: $white;
  border-right: $line-bold solid $line-color-dark;
  width: 50%;
  z-index: 20;
  .nav-wrap {
    position: fixed;
    background-color: $black;
    // width: calc(#{$col6} + #{$grid-padding});
    width: 50%;
    height: $nav-height;
    border-bottom: $line-bold solid $line-color-dark;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .close {
      padding: 0 $main-margin;
      display: flex;
      align-items: center;
      .icon-cancel {
        padding: 0;
        fill: $white;
      }
    }
  }
  .content-wrap {
    margin-top: calc(#{$big-margin} + #{$nav-height});
    margin-left: $grid-padding;
    padding-bottom: 200px;
  }
  .bottom-links {
    position: fixed;
    bottom: 0;
    width: 50%;
    padding: $nav-height 0;
    background-image: linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,1) 50%, rgba(0,0,0,1) 100%);
    p {
        margin-left: $grid-padding;
        span {
            margin-right: $icon-margin;
            white-space: pre;
        }
    }
  }
}


// MOBILE
@media #{$mobile} {    
    .menu {
      width: 100vw;
      .nav-wrap { 
        width: 100vw;
        height: $nav-height-mobile;
        .title {
          margin-left: $main-margin-mobile;
        }
        .close {
          position: absolute;
          right: 0;
          padding: $main-margin-mobile;
        }
      }
      .content-wrap {
        padding: 0;
        h1 {
          font-size: $big-h1-mobile;
        }
      }    
    }    
}

</style>